<template>
  <div class="link_02">
    <div class="jugadores-plantilla avenirnextltpro-medium-big-stone-10px" @click="clickBreadCrumbs(2)">
      Jugadores - Plantilla
    </div>
  </div>
</template>

<script>
export default {
  name: 'Link02',
  props: {
    player: {
      type: Object,
      required: true,
    },
  },
  methods: {
    clickBreadCrumbs(id) {
      if (id == 2) {
        this.$router.push(
          `/playersAnalysis/teams/` +
            window.localStorage.getItem('LTeamForPlayersView') +
            `?teamName=` +
            window.localStorage.getItem('LTeamNameForPlayersView'),
        );
      }
    },
  },
};
</script>

<style>
.link_02,
.link_02-1,
.link_02-2,
.link_02-3 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 2px 4px;
  position: relative;
  width: fit-content;
}

.jugadores-plantilla,
.jugadores-plantilla-1,
.jugadores-plantilla-2,
.jugadores-plantilla-3 {
  letter-spacing: -0.1px;
  line-height: 17px;
  margin-top: -2px;
  position: relative;
  text-align: center;
  text-decoration: underline;
  white-space: nowrap;
  width: fit-content;
}
.jugadores-plantilla:hover {
  color: #23b0ff;
  cursor: pointer;
}
</style>
